import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CmsService, OccEndpointsService } from '@spartacus/core';
import { Subscription, take } from 'rxjs';

@Component({
  selector: 'app-custom-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './custom-banner.component.html',
  styleUrls: ['./custom-banner.component.scss'],
})
export class CustomBannerComponent implements OnInit, OnDestroy {
  prodBanner = {};
  cmsSub: Subscription;
  constructor(
    private readonly cmsService: CmsService,
    private readonly occService: OccEndpointsService
  ) {}

  ngOnInit(): void {

    this.cmsSub = this.cmsService.getComponentData('ProductGridHorizontalBannerComponent').pipe(take(1)).subscribe((res: any) => {
      if(res) {
        const baseUrl = this.occService.getBaseUrl({
          prefix: false,
          baseUrl: true,
          baseSite: false,
        });
      this.prodBanner['src'] = baseUrl + res?.media?.url;
      this.prodBanner['url'] = res?.urlLink;
      this.prodBanner['alt_text'] = res?.media?.name;
    }
    });
  }

  ngOnDestroy(): void {
    this.cmsSub?.unsubscribe();
  }
}
